import * as React from "react";
import { memo } from "react";
import { useFocusable } from "../../../utils/Helpers";
import { useRouter } from "../../../context/Router";
import "./movieBlockViewStyles.css";
import { MoviePoster } from "../movie/MoviePoster";
export var BlockItemCard = memo(function (_a) {
    var item = _a.item, focusRaw = _a.focusRaw, _b = _a.active, active = _b === void 0 ? true : _b;
    var navigate = useRouter().navigate;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () {
            if (!item.targetSlug)
                return;
            navigate("see-more", { slug: item.targetSlug });
        },
    });
    return (React.createElement("div", { tabIndex: 0, ref: ref, className: "movie-card-container" },
        React.createElement(MoviePoster, { url: item.image || "", active: active }),
        React.createElement("p", { className: "movie-title" }, item.title)));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/block/BlockItemCard.tsx
// module id = 118
// module chunks = 1